<script>
import { useAlert } from 'dashboard/composables';
import SettingsFieldSection from 'dashboard/components-next/Settings/SettingsFieldSection.vue';
import NextInput from 'dashboard/components-next/input/Input.vue';
import NextButton from 'dashboard/components-next/button/Button.vue';

export default {
  components: {
    SettingsFieldSection,
    NextInput,
    NextButton,
  },
  props: {
    inbox: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      sipServer: this.inbox.sip_server || '',
      sipUsername: this.inbox.sip_username || '',
      sipPassword: '',
      sipExtension: this.inbox.sip_extension || '',
      sipPort: this.inbox.sip_port || 8089,
      isUpdating: false,
    };
  },
  watch: {
    'inbox.sip_server'(val) {
      this.sipServer = val || '';
    },
    'inbox.sip_username'(val) {
      this.sipUsername = val || '';
    },
    'inbox.sip_extension'(val) {
      this.sipExtension = val || '';
    },
    'inbox.sip_port'(val) {
      this.sipPort = val || 8089;
    },
  },
  methods: {
    async updateSipSettings() {
      this.isUpdating = true;
      try {
        const channelPayload = {
          sip_server: this.sipServer,
          sip_username: this.sipUsername,
          sip_extension: this.sipExtension,
          sip_port: Number(this.sipPort),
        };
        if (this.sipPassword) {
          channelPayload.sip_password = this.sipPassword;
        }
        await this.$store.dispatch('inboxes/updateInbox', {
          id: this.inbox.id,
          formData: false,
          channel: channelPayload,
        });
        this.sipPassword = '';
        useAlert(this.$t('INBOX_MGMT.EDIT.API.SUCCESS_MESSAGE'));
      } catch (error) {
        useAlert(this.$t('INBOX_MGMT.EDIT.API.ERROR_MESSAGE'));
      } finally {
        this.isUpdating = false;
      }
    },
  },
};
</script>

<template>
  <div class="flex flex-col gap-4">
    <SettingsFieldSection
      :label="$t('INBOX_MGMT.ADD.SIP.SIP_SERVER.LABEL')"
      :help-text="$t('INBOX_MGMT.ADD.SIP.SIP_SERVER.PLACEHOLDER')"
    >
      <NextInput v-model="sipServer" />
    </SettingsFieldSection>

    <SettingsFieldSection
      :label="$t('INBOX_MGMT.ADD.SIP.SIP_USERNAME.LABEL')"
      :help-text="$t('INBOX_MGMT.ADD.SIP.SIP_USERNAME.PLACEHOLDER')"
    >
      <NextInput v-model="sipUsername" />
    </SettingsFieldSection>

    <SettingsFieldSection
      :label="$t('INBOX_MGMT.ADD.SIP.SIP_PASSWORD.LABEL')"
      :help-text="$t('INBOX_MGMT.ADD.SIP.SIP_PASSWORD.PLACEHOLDER')"
    >
      <NextInput
        v-model="sipPassword"
        type="password"
        :placeholder="$t('INBOX_MGMT.ADD.SIP.SIP_PASSWORD.KEEP_PLACEHOLDER')"
      />
    </SettingsFieldSection>

    <SettingsFieldSection
      :label="$t('INBOX_MGMT.ADD.SIP.SIP_EXTENSION.LABEL')"
      :help-text="$t('INBOX_MGMT.ADD.SIP.SIP_EXTENSION.PLACEHOLDER')"
    >
      <NextInput v-model="sipExtension" />
    </SettingsFieldSection>

    <SettingsFieldSection
      :label="$t('INBOX_MGMT.ADD.SIP.SIP_PORT.LABEL')"
      :help-text="$t('INBOX_MGMT.ADD.SIP.SIP_PORT.PLACEHOLDER')"
    >
      <NextInput v-model="sipPort" type="number" />
    </SettingsFieldSection>

    <div>
      <NextButton
        :disabled="isUpdating"
        :is-loading="isUpdating"
        :label="$t('INBOX_MGMT.SETTINGS_POPUP.UPDATE')"
        @click="updateSipSettings"
      />
    </div>
  </div>
</template>
